// 音声処理
import common from "@/mixin/common";
import * as constants from "@/mixin/constants";

export default {
  data() {
    return {
      myAudio: null,
      isAudioPlaying: false // Audio再生中かを判断するフラグ
    };
  },
  mixins: [common],
  created() {
    this.log("audio start created");

    this.myAudio = new Audio();
  },
  destroyed() {
    this.log("audio start destroyed");

    if (this.myAudio != null) {
      this.audioPause();
      this.myAudio = null;
    }
  },
  methods: {
    // 音声再生
    audioPlay: function(audioPath, isDisabled) {
      this.log("audio start audioPlay");
      const self = this;

      if (this.myAudio == null) {
        return;
      }

      // 再生
      this.myAudio.src = audioPath;
      this.myAudio.load();
      this.myAudio.play();
      this.isAudioPlaying = true;

      if (!isDisabled) {
        this.disabledIconVoice();
      }
      
      var endedEvent = function(event) {
        $(self.myAudio).off("ended error", endedEvent);
        var errorCode = "";
        try {
          errorCode = event.currentTarget.error.code;
        } catch (e) {
          errorCode = "none";
        }
        self.log("audio end audioPlay errorCode: " + errorCode);
        
        self.isAudioPlaying = false;
        if (!isDisabled) {
          self.enabledIconVoice();
        }
      }
      $(this.myAudio).on("ended error", endedEvent);
    },

    // 音声停止
    audioPause: function() {
      this.log("audio start audioPause");

      if (this.myAudio == null) {
        return;
      }

      if (!this.myAudio.paused) {
        this.myAudio.pause();
        this.enabledIconVoice();
        this.isAudioPlaying = false;
      }
    },

    // 正解音の再生
    audioCorrect: function() {
      this.log("audio start audioCorrect");
      if (this.$store.getters.answerSound == "true") {
        this.audioPlay(constants.AUDIO_CORRECT, true);
      }
    },

    // 不正解音の再生
    audioInCorrect: function() {
      this.log("audio start audioInCorrect");
      if (this.$store.getters.answerSound == "true") {
        this.audioPlay(constants.AUDIO_INCORRECT, true);
      }
    },

    // 音声認識再生音の再生
    audioRecognition: function() {
      this.log("audio start audioRecognition");

      this.audioPlay(constants.AUDIO_RECOGNITION, true);
    },

    // マスク音の再生
    audioMask: function() {
      this.log("audio start audioMask");

      this.audioPlay(constants.AUDIO_MASK, true);
      this.enabledIconVoice();
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/audio.js